import { EntityTypes } from '@/constants/entityTypes'
import { Permissions } from '@/constants/permissionEnums'
import { useTranslation } from '@/features/shared/composables/useTranslation'

const t = useTranslation()

export const campaignRoutes = [
  {
    path: 'listings',
    name: 'Campaigns',
    component: () => import('@/views/Campaigns/Campaigns.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('listings')} | Pour Now`,
      permissionIdentifiers: [Permissions.CAN_VIEW_LISTING],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:campaignId',
    name: 'AddCampaign',
    component: () => import('@/views/Campaigns/AddEditCampaign.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('create_listing')} | Pour Now`,
      permissionIdentifiers: [Permissions.CAN_CREATE_LISTING],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:campaignId',
    name: 'EditCampaign',
    component: () => import('@/views/Campaigns/AddEditCampaign.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('edit_listing')} | Pour Now`,
      permissionIdentifiers: [Permissions.CAN_UPDATE_LISTING],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/brand-styles',
    name: 'CampaignBrandStyles',
    component: () => import('@/views/Campaigns/BrandStyles.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('brand_styles')} | Pour Now`,
      permissionIdentifiers: [Permissions.CAN_VIEW_LISTING_BRAND_STYLES],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:entityId/:campaignId/analytics',
    name: 'CampaignAnalytics',
    component: () => import('@/views/Campaigns/CampaignAnalytics/CampaignAnalytics.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('listing_analytics')} | Pour Now`,
      permissionIdentifiers: [Permissions.CAN_VIEW_LISTING_ANALYTICS],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:campaignId/session-recordings',
    name: 'CampaignSessionRecordings',
    component: () => import('@/views/Campaigns/CampaignAnalytics/CampaignSessionRecordings.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('session_recordings')} | Pour Now`,
      permissionIdentifiers: [Permissions.CAN_VIEW_LISTING_ANALYTICS],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:campaignId/products-config',
    name: 'CampaignProductsConfig',
    component: () => import('@/views/Campaigns/CampaignProductsConfig/CampaignProductsConfigs.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('products_config')} | Pour Now`,
      permissionsIdentifiers: [Permissions.CAN_UPDATE_LISTING],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:campaignId/products-config/:productId/medias',
    name: 'CampaignProductMedias',
    component: () => import('@/views/Campaigns/CampaignProductsConfig/CampaignProductMedias.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('images_and_videos')} | Pour Now`,
      permissionsIdentifiers: [Permissions.CAN_UPDATE_LISTING],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:campaignId/products-config/:productId/hero-content',
    name: 'CampaignProductHeroContent',
    component: () => import('@/views/Campaigns/CampaignProductsConfig/CampaignProductHeroContent.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('hero_content')} | Pour Now`,
      permissionsIdentifiers: [Permissions.CAN_UPDATE_LISTING],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
  {
    path: 'listings/:campaignId/products-config/:productId/retailer-buckets',
    name: 'CampaignProductRetailerBuckets',
    component: () => import('@/views/Campaigns/CampaignProductsConfig/CampaignProductRetailerBuckets.vue'),
    meta: {
      mainRouteName: 'Campaigns',
      title: `${t('retailer_buckets')} | Pour Now`,
      permissionsIdentifiers: [Permissions.CAN_UPDATE_LISTING],
      visibleEntityTypes: [EntityTypes.BRAND],
    },
  },
]
